module.exports = __webpack_public_path__ + "img/Dantam Hair 22.ee8459ef.jpg";